module.exports = __webpack_public_path__ + "static/media/cam2_noite_f.1e467a15.webp";